module.exports = __webpack_public_path__ + "static/media/galeria_elo_04.c91347eb.jpg";